import { styled } from 'styled-components'

const StyledLoader = styled.div`
  height: 100px;
  width: 100vw;
  display: flex;
  justify-content: center;
`

export default StyledLoader
